import {ScrollShadow, Skeleton} from '@heroui/react'
import Footer from './Footer'
import {useDictionary, useItems} from '@adamlip/okeoke.client'
import useBasket from 'hooks/useBasket'
import BasketItem from './BasketItem'
import Delivery from './Delivery'
import Notes from './Notes'
import ServiceFee from './ServiceFee'
import {useContext, useEffect, useState} from 'react'
import {AppParamsContext} from 'contexts/AppParamsContext'
import BarSoftButton from 'components/_NewComponents/BarSoftButton'
import {ExternalLinkIcon, ShoppingBasket} from 'lucide-react'
import {useNavigate} from 'react-router-dom'
import {MainContext} from 'contexts/MainContext'
export default function BasketItems({goToNext, setIsOpen}) {
	const {appParams} = useContext(AppParamsContext)
	const {noSafeAreaInTheApp} = useContext(MainContext)
	const {getValue} = useDictionary()
	const {validation, orderItemsAssembled, order} = useBasket()
	const {assembledItems, sizes} = useItems()

	const [nutritionalValues, setNutritionalValues] = useState({})
	const [sumNutritionalValues, setSumNutritionalValues] = useState({})
	const [isLoaded, setIsLoaded] = useState(false)
	const navigate = useNavigate()
	useEffect(() => {
		let values = {}

		for (let item of Object.values(orderItemsAssembled || {})) {
			if (assembledItems?.[item.itemUUID]) {
				if (Object.keys(assembledItems?.[item.itemUUID]?.nutritionalValues)?.length > 0) {
					values = {
						...values,
						[item.orderItemUUID]: {
							count: item.count,
							...assembledItems?.[item.itemUUID]?.nutritionalValues,
						},
					}
				}
			}
			if (item?.parentOrderItemUUID != null && item?.count > 0) {
				let parentItemIsInTheBasket = Object.values(orderItemsAssembled || {}).find((parentItem) => parentItem?.orderItemUUID === item?.parentOrderItemUUID)
				if (parentItemIsInTheBasket && parentItemIsInTheBasket?.count > 0) {
				} else {
					setTimeout(() => {
						order.updateBasketItemCount(item?.orderItemUUID, 0)
					}, 300)
				}
			}
		}

		setNutritionalValues(values)
	}, [orderItemsAssembled, assembledItems])

	useEffect(() => {
		if (nutritionalValues != null) {
			let sumValues = {
				carbohydrates: 0,
				carbohydratesSugars: 0,
				energykcal: 0,
				energykj: 0,
				fats: 0,
				fatsSaturates: 0,
				fibre: 0,
				protein: 0,
				salt: 0,
			}
			for (let item of Object.values(nutritionalValues || {})) {
				for (let [key, value] of Object.entries(item || {})) {
					if (key !== 'count') {
						sumValues = {
							...sumValues,
							[key]: sumValues?.[key] + item.count * +value,
						}
					}
				}
			}
			setSumNutritionalValues(sumValues)
		}
	}, [nutritionalValues])
	useEffect(() => {
		setTimeout(() => {
			setIsLoaded(true)
		}, 300)
	}, [])

	const haveItems = Object.values(orderItemsAssembled || {})?.filter((item) => item?.parentOrderItemUUID == null && item?.count > 0)?.length > 0
	// if (Object.values(orderItemsAssembled || {}).length < 1) return null;
	return (
		<div className='h-full flex flex-col gap-2 grow'>
			<ScrollShadow className='h-full'>
				<div className='h-full overflow-hidden overflow-y-scroll flex flex-col gap-2	px-2'>
					{isLoaded && !haveItems && (
						<div className='flex flex-col gap-0 w-full h-full justify-center items-center px-2'>
							<ShoppingBasket className='w-16 h-16  ' strokeWidth={1} />
							<div className='text-center font-bold text-lg'>{getValue('app_v2_basket_empty')}</div>
							<div className='text-center opacity-70 text-sm pb-4'>{getValue('app_v2_basket_empty_description')}</div>
							<BarSoftButton
								size='lg'
								variant='solid'
								fullWidth={true}
								color='primary'
								className=''
								onPress={() => {
									setIsOpen(false)
									navigate('/welcome')
								}}
								forceCustom={true}
								endContent={<ExternalLinkIcon className='w-4 h-4' />}>
								{getValue('app_v2_order')}
							</BarSoftButton>
						</div>
					)}
					{!isLoaded && (
						<div className='flex flex-col gap-2'>
							{Array.from({length: 15}).map((_, index) => (
								<Skeleton key={index} className='h-16 w-full rounded-lg' />
							))}
						</div>
					)}
					{validation?.minimumPriceValid === false && <div className='min-price-text'>{`${getValue('app_v2_minimumBasketPrice')}: ${appParams?.basketModal?.minBasketValue} Ft`}</div>}

					{isLoaded &&
						Object.values(orderItemsAssembled || {})
							.filter((item) => item.parentOrderItemUUID == null)
							.filter((item) => (sizes?.[item.selectedSizeUUID]?.attributes?.menuSize ? item.count > 0 : true))
							.map((item) => <BasketItem key={item.orderItemUUID} orderItemUUID={item.orderItemUUID} orderItems={Object.values(orderItemsAssembled || {})} menuSize={item.sizeAttributes?.menuSize} />)}
					{haveItems && <Delivery />}
					{haveItems && <ServiceFee />}
					{appParams?.basketModal?.showNutritionalValues && haveItems && (
						<div className='p-2'>
							{Object.entries(sumNutritionalValues)
								.filter((value) => Number.isInteger(value[1]) && value[1] > 0)
								.map((value) => (
									<div className='flex gap-2' key={value[0]}>
										<div className=''>{getValue(`app_v2_${value[0]}`)}:</div>
										<div className=''>{value[1]}</div>
									</div>
								))}
						</div>
					)}
					{haveItems && <Notes />}
				</div>
			</ScrollShadow>
			{haveItems && <Footer goToNext={goToNext} />}
		</div>
	)
}
